<template>
	<div class="home">
		<Introduce />
		<Partners />
	</div>
</template>


<script>
import Introduce from '@/components/index/Introduce.vue'
import Partners from '@/components/index/Partners.vue'
export default {
  components: {
    Introduce,
    Partners,
  }
}
</script>

<style lang="less" scoped>
.home div {
}
.home div:nth-child(1) {
  margin: 0 0;
}
</style>